export default __webpack_public_path__ + "static/media/footer-desktop-slice.ffb22185.svg";